import { graphql } from "src/gql"
import {
  GetParticipantEventsAndGroupsInput,
  GetSurveyFilterOptionsInput,
  ListUserSurveySummariesInput,
} from "src/gql/graphql"
import { graphqlClient } from "@myvp/shared/src/functions/request"

export const getParticipantEventsAndGroups = async (
  args: GetParticipantEventsAndGroupsInput
) => {
  const query = graphql(/* GraphQL */ `
    query getParticipantEventsAndGroups(
      $input: GetParticipantEventsAndGroupsInput!
    ) {
      getParticipantEventsAndGroups(input: $input) {
        participantNumber
        participantStatus
        participantGroups {
          groupCategory
          selectedGroup
        }
        participantEvents {
          participantEventId
          participantEventStatus
          eventName
          eventDate
          populatedBy
          windowDaysBefore
          windowDaysAfter
          expectedDateTime
          siteTimeZone
          hasCriteriaCheckEventLogs
          didNotOccur
        }
      }
    }
  `)
  const result = await graphqlClient.request(query, {
    input: {
      studyParticipantId: args.studyParticipantId,
    },
  })
  return result.getParticipantEventsAndGroups
}

export const listCriteriaCheckEventLogsForSponsor = async (args: {
  criteriaCheckEventId: string
  siteUserLanguage: string
}) => {
  const query = graphql(/* GraphQL */ `
    query listCriteriaCheckEventLogsForSponsor(
      $input: ListCriteriaCheckEventLogsInput!
    ) {
      listCriteriaCheckEventLogsForSponsor(input: $input) {
        isRestrictingData
        isAssociatedWithRule
        criteriaCheckEventLogs {
          preconditionsSuccess
          preconditionsFallbackMessage
          evaluatedAt
          integrationStatus
          criteriaCheckResults {
            __typename
            displayLabel
            ... on CriteriaCheckResultSection {
              displayLabel
            }
            ... on CriteriaCheckResultValue {
              expressionResultValue
            }
            ... on CriteriaCheckResultToken {
              expressionResultToken
            }
          }
        }
        canAccessRestrictedData
        hasRestrictedLogs
      }
    }
  `)
  const result = await graphqlClient.request(query, {
    input: {
      participantEventId: args.criteriaCheckEventId,
      siteUserLanguage: args.siteUserLanguage,
    },
  })
  return result.listCriteriaCheckEventLogsForSponsor
}

export const listUserSurveySummariesForSponsor = async (
  args: ListUserSurveySummariesInput
) => {
  const query = graphql(/* GraphQL */ `
    query listUserSurveySummariesForSponsor(
      $input: ListUserSurveySummariesInput!
    ) {
      listUserSurveySummariesForSponsor(input: $input) {
        participantNumber
        pageOutputParams {
          totalElements
        }
        userSurveySummaries {
          userSurveyId
          surveyLabel
          surveyStatus
          event {
            eventLabel
            unscheduledEventInstance
          }
          respondent {
            __typename
            ... on CaregiverRespondent {
              relationshipToParticipant
            }
          }
          actionDateTime
          actionTimezone
          isRestricted
          dataAvailability
          signatureStatus
          dataChangeRequestId
          parentUserSurveyId
          partLabel
        }
      }
    }
  `)
  const result = await graphqlClient.request(query, {
    input: {
      studyParticipantId: args.studyParticipantId,
      surveyFilter: args.surveyFilter,
      paginationInput: args.paginationInput,
      siteUserLanguageTag: args.siteUserLanguageTag,
    },
  })
  return result.listUserSurveySummariesForSponsor
}

export const getSurveyFilterOptionsForSponsor = async (
  args: GetSurveyFilterOptionsInput
) => {
  const query = graphql(/* GraphQL */ `
    query getSurveyFilterOptionsForSponsor(
      $input: GetSurveyFilterOptionsInput!
    ) {
      getSurveyFilterOptionsForSponsor(input: $input) {
        surveyFilterOptions {
          surveyLabel
          surveyIds
        }
        eventFilterOptions: eventFilterOptionsV2 {
          eventLabel
          unscheduledEventInstance
          participantEvents {
            eventLabel
            studyEventGroupId
            unscheduledEventInstance
            collectionIds
          }
        }
        statusFilterOptions
        respondentFilterOptions
        signatureStatusFilterOptions
      }
    }
  `)
  const result = await graphqlClient.request(query, {
    input: {
      siteUserLanguageTag: args.siteUserLanguageTag,
      studyParticipantId: args.studyParticipantId,
    },
  })
  return result.getSurveyFilterOptionsForSponsor
}
